<template>
  <div class="p-6 bg-white shadow-md rounded-lg px-4 card card-outline card-info">
    <h2 class="text-md font-bold text-gray-800 mb-6 flex">Reporte Global de Evaluaciones</h2>
    <hr/>

    <div v-if="loading" class="text-gray-600">Cargando datos...</div>

    <div v-if="!loading && reportData">
      <div>
        <h5 class="font-bold text-md mb-2">{{ reportData.name }}</h5>
      </div>

      <div v-if="reportData.averageEvaluations.length">
          <table class="min-w-full table-auto mt-6 w-full"  style="margin-top: 5px; width: 100%;">
          <thead>
            <tr>
              <th class="px-4 py-2 text-center" colspan="4">Promedio de Evaluaciones</th>
            </tr>
            <tr>
              <th class="px-4 py-2 text-left">Competencia</th>
              <th class="px-4 py-2 text-left">Promedio Autoevaluación</th>
              <th class="px-4 py-2 text-left">Promedio Evaluación Jefe</th>
              <th class="px-4 py-2 text-left">Promedio Evaluación Terceros</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="competency in reportData.averageEvaluations[0]?.competency_scores" :key="competency.competency_name">
              <td class="border px-4 py-2">{{ competency.competency_name }}</td>
              <td class="border px-4 py-2 flex justify-between">
                <span v-if="getAutoScore(competency.competency_name) !== null">
                  {{ formatNumberDecimal(getAutoScore(competency.competency_name)) }} Pts
                </span>
                <span v-else>N/A</span>
                 <span v-if="getCommentScore(getAutoId(competency.competency_name), 'autoevaluation') !== null" style="cursor: pointer;" class="ml-3 cursor-pointer" @click="openModalComment(getCommentScore(getAutoId(competency.competency_name), 'autoevaluation'))">
                  <i class="fa-solid fa-comment"></i>
                  <!-- Comentario: {{ getCommentScore(getAutoId(competency.competency_name), 'autoevaluation') }} -->
                </span>
              </td>              
              <td class="border px-4 py-2">
                  <!-- Aquí estamos mostrando el promedio de evaluación de Manager -->
                  <p v-if="getManagerScore(competency.competency_name) !== null">
                    {{ formatNumberDecimal(getManagerScore(competency.competency_name)) }} Pts
                  </p>
                  <p v-else>N/A</p>
                  <p v-if="getCommentScore(getManagerId(competency.competency_name),'manager') !== null">
                    Comentario: {{ getCommentScore(getManagerId(competency.competency_name),'manager') }}
                  </p>
                </td>
                <td class="border px-4 py-2">
                <!-- Aquí estamos mostrando el promedio de evaluación de Manager -->
                <p v-if="getThirdScore(competency.competency_name) !== null">
                  {{ formatNumberDecimal(getThirdScore(competency.competency_name)) }} Pts
                </p>
                <p v-else>N/A</p>
                <p v-if="getCommentScore(getThirdId(competency.competency_name),'manager') !== null">
                  Comentario: {{ getCommentScore(getThirdId(competency.competency_name),'manager') }}
                </p>
              </td>
            </tr>
          </tbody>
          </table>

          <table class="min-w-full table-auto mt-6 w-full" style="margin-top: 15px; width: 100%;" v-if="reportData.lastPlanCompleted.length > 0">
          <thead>
             <tr>
              <th class="px-4 py-2 text-md text-center" colspan="3">Plan de mejora de competencias</th>
             </tr>
            <tr>
              <th class="px-4 py-2 text-left">Competencia</th>
              <th class="px-4 py-2 text-left">Plan de mejora</th>
              <th class="px-4 py-2 text-left">Porcentaje de Avance</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="competency in reportData.lastPlanCompleted[0].plan_individual_responses" :key="competency.id">
              <td class="border px-4 py-2">{{ competency.plan_competency.competency.name }}</td>
              <td class="border px-4 py-2">{{ competency.plan_competency.improvement_plan }}</td>
              <td class="border px-4 py-2">{{ competency.progress_percentage }} %</td>
            </tr>
          </tbody>
          </table>

          <table class="min-w-full table-auto mt-6 w-full" style="margin-top: 15px; width: 100%;" v-if="reportData.scopeEvaluations.length > 0">
            <thead>
              <tr>
                <th class="px-4 py-2 text-md text-center" colspan="4">Calificaciones de objetivos</th>
              </tr>
              <tr>
                <th class="px-4 py-2 text-left" rowspan="2">Objetivo</th>
                <th class="px-4 py-2 text-center" colspan="3">Porcentaje de cumplimiento</th>
              </tr>
              <tr>
                <th class="px-4 py-2 text-left">Valor del Objetivo</th>
                <th class="px-4 py-2 text-left">Porcentaje total alcanzado</th>
                <th class="px-4 py-2 text-left">Porcentaje alcanzado del objetivo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="competency in reportData.scopeEvaluations" :key="competency.id">
                <td class="border px-4 py-2">{{ competency.scope_goal_name }}</td>
                <td class="border px-4 py-2">{{ competency.scope_goal_percentage }} %</td>
                <td class="border px-4 py-2">{{ competency.real_progress_percentage }} %</td>
                <td class="border px-4 py-2">{{ competency.average_score }} %</td>
              </tr>
            </tbody>
          </table>

          <!-- <table class="min-w-full table-auto mt-6" style="margin-top: 15px;" v-if="reportData.lastPlanCompleted.length > 0">
            <thead>
              <tr>
                <th class="px-4 py-2 text-md text-center" colspan="3">Plan individual de mejora</th>
              </tr>
              <tr>
                <th class="px-4 py-2 text-left">Competencia</th>
                <th class="px-4 py-2 text-left">Plan mejora</th>
                <th class="px-4 py-2 text-left">Porcentaje de cumplimiento</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="competency in reportData.lastPlanCompleted[0].plan_individual_responses" :key="competency.id">
                <td class="border px-4 py-2">{{ competency.plan_competency.competency.name }}</td>
                <td class="border px-4 py-2">{{ competency.plan_competency.improvement_plan }}</td>
                <td class="border px-4 py-2">{{ competency.progress_percentage }} %</td>
              </tr>
            </tbody>
          </table> -->

      </div>
      <div v-else>
        <p>No hay datos para mostrar.</p>
      </div>
    </div>

    <div v-if="error" class="text-red-600 mt-4">{{ error }}</div>
    <ModalComment v-if="isModalCommentOpen" :comment="comment" @close="closeModalComment" />
  </div>
</template>

<script>
import request from "@/services/request";
import ModalComment from "@/component/evaluations/ModalComment.vue";

export default {
  components: {
    ModalComment,
  },
  data() {
    return {
      reportData: null,
      loading: true,
      error: null,
      comment: null,
      isModalCommentOpen: false,
    };
  },
  mounted() {
    this.fetchReportData();
  },
  methods: {
    async fetchReportData() {
      try {
        const { data } = await request.list("/evaluations/mine-report");
        this.reportData = data.data;
      } catch (err) {
        console.error("Error al cargar los datos:", err);
        this.error = "No se pudo cargar el reporte. Inténtelo más tarde.";
      } finally {
        this.loading = false;
      }
    },
    formatNumberDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    openModalComment(comment) {
      this.comment = comment;
      this.isModalCommentOpen = true;
    },
    closeModalComment() {
      this.isModalCommentOpen = false;
    },
    // Esta función busca el promedio de evaluación de Manager para una competencia específica
    getManagerScore(competencyName) {
      if(this.reportData.managerEvaluations[0]?.competency_scores){        
        const managerEval = this.reportData.managerEvaluations[0]?.competency_scores.find(
          (comp) => comp.competency_name === competencyName
        );
        return managerEval ? managerEval.average_score : null;
      }else{
        return null;
      }
    },
    
    // Esta función busca el promedio de evaluación de Manager para una competencia específica
    getThirdScore(competencyName) {
      if(this.reportData.thirdsEvaluations?.[0]?.competency_scores){        
        const managerEval = this.reportData.thirdsEvaluations[0].competency_scores.find(
          (comp) => comp.competency_name === competencyName
        );
        return managerEval ? managerEval.average_score : null;
      }else{
        return null;
      }
    },
    getAutoScore(competencyName) {
      if (this.reportData.autoevaluations[0]?.competency_scores) {
        const managerEval = this.reportData.autoevaluations[0]?.competency_scores.find(
          (comp) => comp.competency_name === competencyName
        );
        return managerEval ? managerEval.average_score : null;      
     }else{
      return null;
     }
      
    },
    
     getAutoId(competencyName) {
      const managerEval = this.reportData.autoevaluations[0]?.competency_scores.find(
        (comp) => comp.competency_name === competencyName
      );
      return managerEval ? managerEval.competency_id : 0;
    },

     getManagerId(competencyName) {
      const managerEval = this.reportData.averageEvaluations[0]?.competency_scores.find(
        (comp) => comp.competency_name === competencyName
      );
      return managerEval ? managerEval.competency_id : 0;
    },
    getThirdId(competencyName) {
      const managerEval = this.reportData.thirdsEvaluations[0]?.competency_scores.find(
        (comp) => comp.competency_name === competencyName
      );
      return managerEval ? managerEval.competency_id : 0;
    },

    getCommentScore(competency_id, type = 'autoevaluation') {
      if(type === 'autoevaluation'){
        const comment = this.reportData.autoevaluations[0]?.comments.find(
        (comp) => comp.competency_id === competency_id
        );
        return comment ? comment : null;
      } else {
        const comment = this.reportData.managerEvaluations[0]?.comments.find(
        (comp) => comp.competency_id === competency_id
        );
       return comment ? comment : null;

      }
    },
  },
};
</script>

<style scoped>
th {
  background-color: #f3f4f6;
  font-weight: bold;
}
.min-w-full{
  min-width:70%;
}
</style>
